define ['./payment_info.css'], () ->

  ($rootScope, $scope, $state, RentappService, $stateParams, $http, RENTAPPLICATION_API_URL, Account, Flash, Landlord) ->
    $scope.secure_svg = require('./../secure.svg')

    $scope.card = {}

    $scope.account_settings = angular.copy($stateParams.account_settings)
    $scope.account = $stateParams.account

    Landlord.getMe().$promise.then (me) ->
      if me.my_payments_fee || me.my_payments_fee == 0
        $scope.my_payments_fee = me.my_payments_fee
      else
        $scope.my_payments_fee = 34.95

    $scope.enable_payments = () ->
      #if not $scope.enabledPaymentsForm.$valid
      #  return
      $scope.errors = null
      $scope.submitting = true

      RentappService.getStripe().then((stripe) ->
        stripe.createToken($scope.card)
          .then((result) ->
            if result.error
              #Inform the user if there was an error.
              $rootScope.$broadcast("card-error", result.error)
              Flash.create('danger', response.error.message, 3000, {class: 'error'}, true)
              $scope.submitting = false
            else
              data = $scope.account_settings
              data.stripeToken = result.token.id
              data.payment_receipt = $scope.card.payment_receipt

              RentappService.getMe()
                .then((user) ->
                  $http.post "#{RENTAPPLICATION_API_URL}/api/v1/account/#{user.landlord.account.id}/setup_bank_info/", data
                    .then () ->
                      $state.go "root.dashboard.payments.confirm"
                      $rootScope.$broadcast("payment-activated")
                    .catch (r) ->
                      errors = []
                      for k,v of r.data
                        if ":" in v
                          # Stripe Error
                          errors.push(v[0].split(':')[1].trim())
                        else
                          # form Error
                          errors.push(k + ": " + v + "<br>")
                      $state.go("root.dashboard.payments.bank_account_info", { errors: errors.join("\n"), account_settings: $scope.account_settings, account: $scope.account })
                    .finally (r) ->
                      $scope.submitting = false
                )
          )
      )





// WEBPACK FOOTER //
// ./components/dashboard/payments/signup/payment_info/payment_info.coffee